import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { useContext } from "react";
import { ApplicationState } from "../../../context/ApplicationStateContext";
import { useOktaAuth } from "@okta/okta-react";
import buildParams from "../../helpers/paramsBuilder";
import SearchPatientsResponse from "../../../models/API/responseModels/searchPatientsDataResponse.model";
import axiosInstance from "../../../api";

interface UseSearchPatientsOptions {
  enabled?: boolean;
}

function useSearchPatients(
  query: string,
  patientDob: string,
  oktaAuth?: any,
  options?: UseSearchPatientsOptions
): UseQueryResult<SearchPatientsResponse> {
  const {
    state: { selectedOrganization: organizationId },
  } = useContext(ApplicationState);
  const authState = useOktaAuth()?.authState;
  const token =
    authState?.accessToken?.accessToken ??
    oktaAuth?.authState?.accessToken?.accessToken;

  const shouldFetch =
    (options?.enabled ?? true) && !!token && (!!query || !!patientDob);

  return useQuery({
    queryKey: ["searchPatients", { organizationId, query, patientDob }],
    queryFn: ({ queryKey }) => {
      const [, { organizationId, query, patientDob }]: any = queryKey;
      const trimmedQuery = (query as string).trim();

      return axiosInstance
        .get(
          `/v1/patients/new-flow${buildParams({
            organizationId,
            query: trimmedQuery,
            patientDob,
          })}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((res) => {
          return res.data;
        });
    },
    retry: false,
    enabled: shouldFetch,
  });
}

export default useSearchPatients;
